import Store from 'state/Store';
import {
  addContentFragment,
  errorContentFragment
} from 'state/contentFragments/ContentFragmentActions';

const isStage = window && window.location.host.includes('stage');

//TODO: Refactor this to use String Literal
const deceased1Url = isStage
  ? 'https://wwwstage.troweprice.com/personal-investing/resources/planning/life-events/inherited-account/death-notification/faqs/deceased-information-1.model.json'
  : 'https://www.troweprice.com/personal-investing/resources/planning/life-events/inherited-account/death-notification/faqs/deceased-information-1.model.json';
const deceased2Url = isStage
  ? 'https://wwwstage.troweprice.com/personal-investing/resources/planning/life-events/inherited-account/death-notification/faqs/deceased-information-2.model.json'
  : 'https://www.troweprice.com/personal-investing/resources/planning/life-events/inherited-account/death-notification/faqs/deceased-information-2.model.json';
const deathCertUrl = isStage
  ? 'https://wwwstage.troweprice.com/personal-investing/resources/planning/life-events/inherited-account/death-notification/faqs/death-certificate.model.json'
  : 'https://www.troweprice.com/personal-investing/resources/planning/life-events/inherited-account/death-notification/faqs/death-certificate.model.json';
const submitterDetailsUrl = isStage
  ? 'https://wwwstage.troweprice.com/personal-investing/resources/planning/life-events/inherited-account/death-notification/faqs/submitter-details.model.json'
  : 'https://www.troweprice.com/personal-investing/resources/planning/life-events/inherited-account/death-notification/faqs/submitter-details.model.json';
const reviewSubmitUrl = isStage
  ? 'https://wwwstage.troweprice.com/personal-investing/resources/planning/life-events/inherited-account/death-notification/faqs/review-and-submit.model.json'
  : 'https://www.troweprice.com/personal-investing/resources/planning/life-events/inherited-account/death-notification/faqs/review-and-submit.model.json';

const contentFragmentUrls = [
  {
    step: 0,
    url: deceased1Url
  },
  {
    step: 1,
    url: deceased2Url
  },
  {
    step: 2,
    url: deathCertUrl
  },
  {
    step: 3,
    url: submitterDetailsUrl
  },
  {
    step: 6,
    url: reviewSubmitUrl
  }
];

export const getContentFragments = () => {
  contentFragmentUrls.forEach(fragment => {
    fetch(fragment.url)
      .then((response) => response.json())
      .then(
        (json) =>
          Store.dispatch(addContentFragment(json[':items'].root[':items'], fragment.step))
      )
      .catch(() => Store.dispatch(errorContentFragment()));
  });
}